/**
 * @generated SignedSource<<7c852fc5bc5a92f0186eaef89b8ec6a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TentativeProjectsToggle_account$data = {
  readonly projects: ReadonlyArray<{
    readonly active: boolean;
    readonly confirmed: boolean;
    readonly id: number;
    readonly name: string;
  }>;
  readonly " $fragmentType": "TentativeProjectsToggle_account";
};
export type TentativeProjectsToggle_account$key = {
  readonly " $data"?: TentativeProjectsToggle_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"TentativeProjectsToggle_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectsFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TentativeProjectsToggle_account",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "projectsFilter"
        }
      ],
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "projects",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "confirmed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "b75ec9266859bad3906e2933575ef31a";

export default node;
